import Section from './section';

const options = {
  container: '.site-content'
};
const instance = new Section(options);

export default instance;



// WEBPACK FOOTER //
// ./src/modules/section-content/index.js